/* Session token set after the secret-menu password is verified. The
 * monetization override is honored only while it exists (sessionStorage,
 * cleared when the tab closes), so a stale localStorage override cannot
 * affect the app outside an authenticated secret-menu session. Guarded for
 * SSR: pages are prerendered at build time, where sessionStorage is absent. */
const SECRET_MENU_SESSION_KEY = 'secretMenu:session';

export const hasSecretMenuSession = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return sessionStorage.getItem(SECRET_MENU_SESSION_KEY) !== null;
};

export const startSecretMenuSession = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem(SECRET_MENU_SESSION_KEY, JSON.stringify(true));
};

export const endSecretMenuSession = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.removeItem(SECRET_MENU_SESSION_KEY);
};
